<template>
  <!--==========================
    Services Section
  ============================-->
  <section id="services">
    <div class="container">
      <!-- Section Header -->
      <div class="section-header text-center mb-5">
        <h3 class="section-title">Services</h3>
        <p class="section-description">IBM i Development Services</p>
      </div>

      <!-- Service Boxes -->
      <div class="row">

          <div class="col-lg-4 col-md-6">
            <div class="box">
              <div class="icon mb-3"><font-awesome-icon icon="desktop" size="2x" /></div>
              <h4 class="title">Requirements Gathering and System Analysis</h4>
              <p class="description">The start of a project and one of the most important steps whose output will go on to form part of the comprehensive project documentation.</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="box">
              <div class="icon mb-3"><font-awesome-icon icon="chart-bar" size="2x" /></div>
              <h4 class="title">Application Design</h4>
              <p class="description">Following the gathering and analysis step the application design will be produced in the form of thorough and comprehensive specifications.</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="box">
              <div class="icon mb-3"><font-awesome-icon icon="paper-plane" size="2x" /></div>
              <h4 class="title">Application Development</h4>
              <p class="description">An expert in IBM RPG, DB2 for i and SQL plus solid skills using Node.js, HTML, CSS, JavaScript and even a bit of Ruby on Rails.</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="box">
              <div class="icon mb-3"><font-awesome-icon icon="image" size="2x" /></div>
              <h4 class="title">Application Testing</h4>
              <p class="description">Often comes late in the development cycle and for this reason, and where possible, I try to implement TDD techniques on back-end routines and insist on strong documentation.</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="box">
              <div class="icon mb-3"><font-awesome-icon icon="road" size="2x" /></div>
              <h4 class="title">Application Deployment</h4>
              <p class="description">A huge advocate of automated deployment routines, tried and tested before implemented in a production environment.</p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="box">
              <div class="icon mb-3"><font-awesome-icon icon="bag-shopping" size="2x" /></div>
              <h4 class="title">Application Maintenance</h4>
              <p class="description">Excellent problem analysis and investigation skills; allowing for quick, and often easy, problem resolution.</p>
            </div>
          </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ServicesSection",
};
</script>
